const socialNetworks = [
    // {socialNetwork: "", icon: "/Icon-Email.png"},
    {socialNetwork: "https://www.facebook.com/sharer.php?u=", icon: "/Icon-Facebook.png"},
    {socialNetwork: "https://twitter.com/intent/tweet?url=", icon: "/Icon-Twitter.png"},
    // {socialNetwork:"#",icon:"/Icon-Instragram.png"},
    {socialNetwork: "https://wa.me/?text=", icon: "/Icon-WhatsApp.png"},
    {socialNetwork: "https://www.linkedin.com/shareArticle?mini=true&url=", icon: "/Icon-LinkedIn.png"},
]

export default socialNetworks;